var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85D4EE",
    d: "M49.988 0c27.614 0 50 22.386 50 50 0 27.613-22.387 50-50 50s-50-22.387-50-50c0-27.614 22.386-50 50-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F95BC",
    d: "M92.73 75.955c-.233.029-.476.045-.726.045-4.024 0-6.004-4-6.004-4s-2.09 3.996-6.016 4c-3.957-.004-5.948-4-5.948-4s-1.991 4-6.024 4c-4.023 0-6.003-4-6.003-4s-2.091 3.996-6.015 4c-3.958-.004-5.95-4-5.95-4s-1.991 4-6.024 4c-4.022 0-6.003-4-6.003-4s-2.091 3.996-6.015 4c-3.958-.004-5.95-4-5.95-4s-1.991 4-6.023 4c-4.023 0-6.004-4-6.004-4s-2.09 3.996-6.015 4c-.267 0-.523-.021-.771-.057 8.771 14.424 24.635 24.057 42.749 24.057 18.11 0 33.97-9.628 42.742-24.045z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M64.85 96l-3.494-50h-22.818l-3.494 50s-.073 1.506-.056 1.512v.196c4.735 1.487 9.773 2.292 15 2.292s10.265-.805 15-2.292l-.138-1.708z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M38.259 50h23.376l-.14-2h-23.097z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECC6C",
    d: "M38.988 29h22v15h-22v-15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M49.988 19l9 8h-18l9-8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M39 98.779l3.717-52.779h-4.179l-3.494 50s-.073 1.506-.056 1.512v.196c1.314.413 2.654.769 4.012 1.071z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M38.259 50h4.177l.14-2h-4.178z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M56.755 46l3.733 52.885c1.525-.326 3.029-.715 4.5-1.177l-.138-1.708-3.494-50h-4.601z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M57.037 50h4.598l-.14-2h-4.599z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1C266",
    d: "M38.988 29h11v15h-11z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M61.988 44h-1v-5h2c.553 0 1-.447 1-1 0-.552-.447-1-1-1h-26c-.553 0-1 .448-1 1 0 .553.447 1 1 1h2v5h-1c-1.104 0-2 .896-2 2 0 1.105.896 2 2 2h24c1.104 0 2-.895 2-2 0-1.104-.895-2-2-2zm-21 0v-5h2v5h-2zm4 0v-5h2v5h-2zm4 0v-5h2v5h-2zm4 0v-5h2v5h-2zm4 0v-5h2v5h-2zM38.488 27h23c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5h-23c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M40.988 28.5c0-.828.672-1.5 1.5-1.5h-4c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h4c-.828 0-1.5-.672-1.5-1.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M40.988 27h9v-8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E2574C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.861 70l-.489 7h27.149l-.488-7zM37.839 56l-.489 7h25.194l-.489-7zM64.501 91l-.489-7h-28.129l-.489 7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#CB4E44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.839 56l-.489 7h4.17l.493-7zM36.861 70l-.489 7h4.162l.493-7zM39.548 91l.493-7h-4.158l-.489 7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#E5685E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.461 56l.494 7h4.589l-.489-7zM58.449 70l.494 7h4.578l-.488-7zM64.501 91l-.489-7h-4.574l.496 7z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.e733cd0b.svg";
export { ForwardRef as ReactComponent };